import React from 'react';
export const BreakingPointSection = () => {
  return <section className="w-full py-20 bg-gray-900 text-white" data-id="element-16">
      <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-17">
        <h2 className="text-3xl md:text-5xl font-bold mb-16 text-red-500" data-id="element-18">
          BREAKING POINT
        </h2>
        <div className="mb-12 space-y-8" data-id="element-19">
          <p className="text-3xl md:text-4xl font-serif leading-relaxed" data-id="element-20">
            "Co jeśli zostanę sama? Kto będzie chciał 46-letnią kobietę z dwójką
            dzieci?"
          </p>
          <p className="text-3xl md:text-4xl font-serif leading-relaxed" data-id="element-21">
            "Co jeśli moje dzieci dorastają bez ojca przez mój egoizm?"
          </p>
          <p className="text-3xl md:text-4xl font-serif leading-relaxed" data-id="element-22">
            "Co jeśli to wszystko to moja wina?"
          </p>
        </div>
        <div className="flex justify-center mb-12" data-id="element-23">
          <div className="w-16 h-16 relative" data-id="element-24">
            <div className="absolute inset-0 bg-red-500 rounded-full animate-ping opacity-25" data-id="element-25"></div>
            <div className="relative w-full h-full flex items-center justify-center" data-id="element-26">
              <svg className="w-10 h-10 text-red-500" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" data-id="element-27">
                <path fillRule="evenodd" d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z" clipRule="evenodd" data-id="element-28"></path>
              </svg>
            </div>
          </div>
        </div>
        <p className="text-xl text-gray-300" data-id="element-29">przerażająca myśl</p>
        <div className="mt-16 bg-gray-800 p-6 rounded-lg" data-id="element-30">
          <div className="flex items-center justify-between mb-4" data-id="element-31">
            <div className="w-3 h-3 bg-red-500 rounded-full" data-id="element-32"></div>
            <div className="h-px bg-gray-700 flex-1 mx-4" data-id="element-33"></div>
            <div className="text-xl font-bold" data-id="element-34">Ta noc zmieniła wszystko</div>
            <div className="h-px bg-gray-700 flex-1 mx-4" data-id="element-35"></div>
            <div className="w-3 h-3 bg-red-500 rounded-full" data-id="element-36"></div>
          </div>
          <p className="text-gray-300" data-id="element-37">
            Leżałam, patrząc w sufit. Łzy spływały po mojej twarzy. To była
            chwila, gdy zdałam sobie sprawę, że nie mogę tak dłużej. Albo coś
            się zmieni, albo moje małżeństwo umrze w ciszy.
          </p>
        </div>
        <div className="mt-12" data-id="element-38">
          <div className="bg-red-900/30 p-4 rounded-lg inline-block" data-id="element-39">
            <div className="flex items-center space-x-4" data-id="element-40">
              <div className="text-xl font-bold" data-id="element-41">
                To, co nastąpiło potem, zmieniło WSZYSTKO...
              </div>
              <div className="flex" data-id="element-42">
                <span className="countdown-item" data-id="element-43">
                  <span className="bg-white text-red-600 w-8 h-8 flex items-center justify-center rounded" data-id="element-44">
                    0
                  </span>
                </span>
                <span className="countdown-item" data-id="element-45">
                  <span className="bg-white text-red-600 w-8 h-8 flex items-center justify-center rounded" data-id="element-46">
                    3
                  </span>
                </span>
                <span className="text-white mx-1" data-id="element-47">:</span>
                <span className="countdown-item" data-id="element-48">
                  <span className="bg-white text-red-600 w-8 h-8 flex items-center justify-center rounded" data-id="element-49">
                    0
                  </span>
                </span>
                <span className="countdown-item" data-id="element-50">
                  <span className="bg-white text-red-600 w-8 h-8 flex items-center justify-center rounded" data-id="element-51">
                    0
                  </span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};